import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ApiErrorHandlerProvider} from "../api-error-handler/api-error-handler";

/*
  Generated class for the TimezoneProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class TimezoneProvider {

    errors: {};
    loading: boolean;

    constructor(public http: HttpClient, private apiErrorHandler: ApiErrorHandlerProvider) {

    }

    /**
     *  Get the currency symbol from the the timezone
     *
     * @param team
     */
    public timezone(team) {
        return new Promise((resolve, reject) => {
            if (typeof team === 'object') {
                if (team.timezone) {
                    return resolve(team.timezone.currency_symbol);
                }
            }

            this.http.get(`/timezone/${team}`)
                .subscribe((timezone: any) => {
                    return resolve(timezone.currency_symbol);
                }, error => {
                    this.errors = this.apiErrorHandler.handleError(error);
                    return reject(error)
                }, () => {
                })
        });
    }
}



// WEBPACK FOOTER //
// ./src/providers/timezone/timezone.ts